import React, { useEffect, useState, useContext } from "react";
import "./App.css";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { DataContext } from "./DataContext";

const Home = () => {
  const { globalData, catData, loadings } = useContext(DataContext);
  const [homeResp, setHomeResp] = useState([]);
  const [error, setError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://cms.ctdestinationhartford.com/wp-json/wp/v2/pages/8")
      .then((response) => {
        setHomeResp(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        console.log("error", error);
        setLoading(false);
      });
  }, []);

  const decodeEntities = (encodedString) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString(
      `<!doctype html><body>${encodedString}`,
      "text/html"
    );
    return dom.body.textContent;
  };

  if (loadings) return;
  if (loading) return;
  if (error) return;

  const handleViewDetails = (card) => {
    navigate(`/list/${card.id}`, { state: { cardData: card } });
  };

  // Functions to handle sidebar open/close
  const openSidebar = () => {
    setIsSidebarOpen(true);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div>
      {/* <!-- Header Section --> */}
      <div className="top-section light-purple-bg text-center">
        <img
          src={globalData?.acf?.logo_image || ""}
          alt="Logo"
          className="img-fluid"
        />
      </div>

      {/* <!-- Logo and Welcome Section --> */}
      <div className="welcome-main-section">
        <div className="welcome-section text-center full-width">
          <h2 className="my-3 heading-text">
            {homeResp?.title?.rendered || ""}
          </h2>
          <p className="lead p-text">
            {decodeEntities(homeResp?.content?.rendered) || ""}
          </p>
        </div>

        {/* <!-- Image Card Section --> */}
        <div className="my-4">
          <div className="row row-cols-1 row-cols-sm-2 g-4 page-container">
            {/* <!-- Card 1 --> */}
            {catData?.map((card) => (
              <div className="col" key={card.id}>
                <div className="card h-100" style={{ cursor: "pointer" }}>
                  <div
                    className="link-text"
                    onClick={() => handleViewDetails(card)}
                  >
                    <img
                      src={card?.acf?.category_image}
                      className="card-img-top"
                      alt={card?.name}
                    />
                    <div className="card-body link-text-bg">
                      <p className="card-text heading-text">{card?.name}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <!-- Next Section with 3 Columns --> */}
      <div className="footer-section">
        <div className="row full-width footer-back">
          {/* <!-- First Column: Image --> */}
          <div className="lf-qr col-md-4 d-flex align-items-center justify-content-start">
            {/* <img
              src={globalData?.acf?.hartford_passport_program_qr || ""}
              alt="qr"
              className="img-fluid"
            />
            <span className="hp-qrcode">HARTFORD PASSPORT PROGRAM</span> */}
            <span className="digital-market">Digital Marketing by The Rebellion Group</span>
          </div>
          {/* <!-- Second Column: Icon --> */}
          <div className="col-md-4 d-flex align-items-center justify-content-center">
            <Link to="/">
              {" "}
              <img src={"images/home.svg"} alt="home" className="img-fluid" />
            </Link>
          </div>
          {/* <!-- Third Column: Button --> */}
          <div className="col-md-4 cat-btn">
            <button
              className="btn btn-primary menu-btn"
              onClick={openSidebar} // Open the sidebar
            >
              CATEGORY MENU
              <img src={"/images/arrow.svg"} alt="arrow" />
            </button>
              
          </div>
        </div>
      </div>

      {/* Overlay to close the sidebar */}
      {isSidebarOpen && (
        <div className="overlay sidebar-close" onClick={closeSidebar}></div>
      )}

      {/* Sidebar Offcanvas */}
      <div
        className={`offcanvas offcanvas-end ${isSidebarOpen ? "show" : ""}`}
        tabIndex="-1"
        id="sidebarMenu"
        aria-labelledby="sidebarMenuLabel"
        style={{
          visibility: isSidebarOpen ? "visible" : "hidden",
          zIndex: 1045, // Ensure it is above the overlay
        }}
      >
        <div className="offcanvas-header">
          <h5 id="sidebarMenuLabel" className="secodary-text">
            Category Menu
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeSidebar} // Close the sidebar on button click
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="list-group">
            {catData?.map((item) => (
              <li
                className="list-group-item"
                onClick={() => handleViewDetails(item)}
                key={item.id}
                role="button"
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;